
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'

@Component
export default class Scatter extends Mixins(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'scatter'

  /**
   * List of plugins.
   */
  public plugins = [
    {
      beforeDraw(chart) {
        const { areas } = chart.chart.options
        if (areas) {
          const ctx: CanvasRenderingContext2D = chart.chart.ctx
          const { left, right } = chart.scales['x-axis-1'].margins
          const width = chart.scales['x-axis-1'].width
          const { top, bottom } = chart.scales['y-axis-1'].margins
          const height = chart.scales['y-axis-1'].height

          areas.forEach(area => {
            ctx.fillStyle = area.color
            ctx.strokeStyle = area.strokeColor || 'white'
            ctx.lineWidth = area.strokeWidth || 4

            let { x1 = 0, y1 = 0, x2 = 0, y2 = 0 } = area

            if (x1.toString().includes('%')) x1 = (parseFloat(x1) / 100) * width
            if (x2.toString().includes('%')) x2 = (parseFloat(x2) / 100) * width
            if (y1.toString().includes('%'))
              y1 = (parseFloat(y1) / 100) * height
            if (y2.toString().includes('%'))
              y2 = (parseFloat(y2) / 100) * height

            ctx.fillRect(left + x1, top + y1, x2 - x1, y2 - y1)
            ctx.strokeRect(left + x1, top + y1, x2 - x1, y2 - y1)

            if (area.title) {
              ctx.font = '30px Poppins'
              ctx.textAlign = 'center'
              ctx.textBaseline = 'middle'
              ctx.fillStyle = area.title.color || area.color || 'gray-800'
              ctx.fillText(
                area.title.text,
                left + x1 + (x2 - x1) / 2,
                y2 === height ? y2 + top * 1.5 : top / 2 + y1
              )
            }
          })
        }
      }
    }
  ]
}
